const basePath = 'mobile_app/v1/payment/gateways'
export default {
  /**
   * create() realiza el pago según la pasarela selecionada
   * */
  async create(payment) {
    const response = await Vue.http.post(basePath, {payment})

    return response.data
  },
  /**
   * generateSignature() signature for the body used in paystore
   * */
  async generateSignature(data) {
    const response = await Vue.http.post('mobile_app/v1/payment/gateways/ds_signature', {data})

    return response.data
  }
}
